import type { SchedulingResponse } from './onboarding-scheduling-contracts'
import styles from './SchedulingPage.module.css'

function healthLabel(value: 'GREEN' | 'RED' | 'UNKNOWN') {
  if (value === 'GREEN') return 'Connected'
  if (value === 'RED') return 'Needs attention'
  return 'Not confirmed — refresh or contact Flio support'
}

export function SchedulingSummary({
  scheduling,
}: {
  scheduling: SchedulingResponse
}) {
  if (scheduling.schemaVersion !== 1) return null
  const snapshot = scheduling.snapshot
  if (!snapshot) return null
  const usableProviders = snapshot.providers.filter(
    (provider) => provider.usable
  )

  return (
    <section className={styles.summary} aria-labelledby="scheduling-summary">
      <h2 id="scheduling-summary">Scheduling summary</h2>
      <dl className={styles.metrics}>
        <div>
          <dt>Connected location</dt>
          <dd>{scheduling.selectedLocationName}</dd>
        </div>
        <div>
          <dt>Usable providers</dt>
          <dd>{usableProviders.length}</dd>
        </div>
        <div>
          <dt>Appointment types</dt>
          <dd>{snapshot.appointmentTypes.length}</dd>
        </div>
        <div>
          <dt>Availability records</dt>
          <dd>{snapshot.availabilityCount}</dd>
        </div>
        <div>
          <dt>Operatories</dt>
          <dd>
            {snapshot.resourceHealth.operatories === 'OPTIONAL_EMPTY'
              ? 'None reported (optional)'
              : snapshot.operatories.length}
          </dd>
        </div>
        <div>
          <dt>NexHealth sync</dt>
          <dd>
            Read: {healthLabel(snapshot.syncStatus.read)} · Write:{' '}
            {healthLabel(snapshot.syncStatus.write)}
          </dd>
        </div>
      </dl>

      <div className={styles.types}>
        <h3>Appointment types</h3>
        <ul>
          {snapshot.appointmentTypes.map((appointmentType) => (
            <li key={appointmentType.id}>
              <span>{appointmentType.name}</span>
              <span>{appointmentType.minutes} minutes</span>
            </li>
          ))}
        </ul>
      </div>

      <p className={styles.checkedAt}>
        Last checked {new Date(snapshot.discoveredAtMs).toLocaleString()}
      </p>
    </section>
  )
}
